import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getParameter() {
    return await instance.get("/parameters/get").then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async saveContato(model) {
    return await instance.post("/contatos/save", model).then(
      async response => {
        console.log(response);
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async saveParameter(model) {
    return await instance.post("/parameters/save", model).then(
      async response => {
        console.log(response);
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async saveParamImage(model) {
    console.log(model);
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return await instance.post("/parameters/saveImage", model, config).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  async removeParamImage(item, param) {
    try {
      let response = await instance.delete("/parameters/removeImage/"+item._id+'/'+param);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/parameter.js